<template>
    <div class="m-2">
        {{title}}
        <span v-for="(value, name, index) in has_settlement_token"  :key="index" class="px-2">
                <i class="fa px-1" :class="value.is_active ? 'fa-check text-success' : 'fa-times text-danger'"></i>
                {{ $t(`wallets.bank.${name}`) }}
        </span>
    </div>
</template>

<script>
import {walletService} from "@/common/api.service";

export default {
    name: "active-token",
    props: {
        title: {
            default() {
                return {}
            }
        },
    },
    data() {
        return {
            has_settlement_token: []
        }
    },

    mounted() {
        this.checkSettlementToken();
    },

    methods: {
        checkSettlementToken() {
            let params = {
                wallet_prefix: 'A',
            };

            const activeBanks = this.fetchStarshop
                ? walletService.getStarShopActiveBanks
                : walletService.getActiveBanks;

            activeBanks(params).then(res => {
                this.has_settlement_token = res.data.data;
            });
        },
    },

    computed: {
        slug() {
            return this.$route.params.slug;
        },
        fetchStarshop() {
            return this.slug === 'starshop';
        }
    }
}
</script>

<style scoped>

</style>